import type {CourseApiModel} from '../../../api/course';
import type {CoreClientCoachesAutoassignParams} from '../../../api/types/core/methods';

import {apiRequest} from '../../../api/utils/apiRequest';
import {logger} from '../../../utils/logger';
import {createChannel} from '../channel/channel.create';

/**
 * @param couponId used_coupon_id
 */
export const autoassgnCoach = async (couponId: string | undefined) => {
  if (!couponId) {
    throw new Error('couponId is required');
  }

  const {course}: {course: CourseApiModel} =
    await apiRequest<CoreClientCoachesAutoassignParams>({
      method: 'client.coaches.autoassign',
      params: {
        used_coupon_id: couponId,
      },
    });

  try {
    // to fill direct messsages tab
    await createChannel({channel_type: 'support'});
  } catch (error) {
    logger.error(error);
  }

  return course;
};
